import { combineReducers } from 'redux';

import checkoutReducer, { CheckoutState } from './checkout';

export type MessagePackageState = {
  checkout: CheckoutState;
};

const messagePackageReducer = combineReducers<MessagePackageState>({
  checkout: checkoutReducer,
});

export default messagePackageReducer;
